/* eslint-disable @typescript-eslint/no-explicit-any*/
import { TransactionRule } from '@portal/models/reducers';
import parseTransactionRule from '@portal/utils/mappers';
import { getInstance } from '@portal/repositories/securitySdkConfig';

const GroupApi = {
  createGroup: async (
    name: string,
    roles: string[] | null,
    transactionRule?: TransactionRule
  ) => {
    const instance = getInstance();

    const transfer = parseTransactionRule(transactionRule?.transfer ?? []);
    const billet = parseTransactionRule(transactionRule?.billet ?? []);
    const pix = parseTransactionRule(transactionRule?.pix ?? []);

    const { data } = await instance.post(`/role-group`, {
      name,
      roles,
      transactionRule: {
        transfer,
        pix,
        billet,
      },
    });

    return data;
  },

  listGroup: async (limit = 10, offset: number, name: string) => {
    const instance = getInstance();
    const { data } = await instance.get(`/role-group`, {
      params: { limit, offset, name },
    });

    return data;
  },

  editGroup: async (
    name: string,
    roles: string[] | null,
    id: string,
    transactionRule?: TransactionRule
  ) => {
    const instance = getInstance();

    const transfer = parseTransactionRule(transactionRule?.transfer ?? []);
    const billet = parseTransactionRule(transactionRule?.billet ?? []);
    const pix = parseTransactionRule(transactionRule?.pix ?? []);

    const { data } = await instance.put(`/role-group/${id}`, {
      name,
      roles,
      accountTransactionRules: {
        transfer,
        billet,
        pix,
      },
    });

    return data;
  },

  getGroup: async (id: string) => {
    const instance = getInstance();
    const { data } = await instance.get(`/role-group/${id}`);

    return data;
  },
};

export default GroupApi;
